import { render, staticRenderFns } from "./MetadadosCampoDinamicoTexto.vue?vue&type=template&id=2a1d6be5"
import script from "./MetadadosCampoDinamicoTexto.vue?vue&type=script&lang=js"
export * from "./MetadadosCampoDinamicoTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports